export type ZodTreeError = {
  _errors?: string[];
  [key: string]: ZodTreeError | string[] | undefined;
};

export type State = {
  message?: string; 
  errors?: ZodTreeError 
};

export type FormResultCode = 
  | "VALIDATION_ERROR"
  | "RATE_LIMITED"
  | "DUPLICATE_ENTRY"
  | "SERVER_ERROR"
  | "SUCCESS";

export type FormResult = {
  success: boolean;
  message: string;
  errors?: Record<string, string[]>;
  code?: FormResultCode;
};

export function getFieldErrors(node: ZodTreeError | string[] | undefined): string[] {
  if (!node) return [];
  if (Array.isArray(node)) return node;
  return node._errors ?? [];
};

export const initialState: State = { message: "", errors: {} };